// Centralized helper to determine the best icon URL for a workcell-like object.
// Accepts objects with fields like: icon_url, icon_path, icon, workcell_icon, workcell_id
export default function getIconSrc(wc) {
  if (!wc) return null;
  if (wc.icon_url) return wc.icon_url;
  if (wc.icon_path) return wc.icon_path;
  if (wc.icon) return wc.icon;
  if (wc.workcell_icon) return wc.workcell_icon;
  if (wc.workcell_id) return `/api/workcell-icon/${wc.workcell_id}`;
  return null;
}
